import { createUseStyles } from 'react-jss';
var useMobileMenuStyles = createUseStyles(function (_ref) {
  var palette = _ref.palette,
    spacing = _ref.spacing,
    type = _ref.type;
  return {
    MobileMenuAnon: {
      '& .sm-mobile-menu-anon__anchor': {
        '&:hover, &:focus': {
          textDecoration: 'none'
        }
      },
      '& .sm-mobile-menu-anon__link': {
        textDecoration: 'none',
        outline: 0,
        color: palette.text.dark
      },
      '& .sm-mobile-menu-anon__cta': {
        width: "calc(100% - ".concat(spacing[8], "px)"),
        margin: [spacing[5], spacing[6]],
        outline: 0
      }
    }
  };
});
export default useMobileMenuStyles;
//# sourceMappingURL=useMobileMenuStyles.js.map